import script from "./add-filter-search.vue?vue&type=script&setup=true&lang=ts"
export * from "./add-filter-search.vue?vue&type=script&setup=true&lang=ts"

import "./add-filter-search.vue?vue&type=style&index=0&id=dcfe29d3&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dcfe29d3"]])

export default __exports__